module.exports = __webpack_public_path__ + "static/media/icon_techo.409d2063.svg";